import {Component, Input} from "@angular/core";
import {AbstractValueAccessor, MakeProvider} from "./abstract-value-accessor";
import {DkNumberPipe} from "./../pipes/dk-number";
import {ControlValueAccessor} from '@angular/forms';

@Component({
    selector : 'dk-number-input',
    template: '<input [id]="inputId" dkCurrencyInput [readonly]="inputReadonly" [ngModel]="value" (ngModelChange)="onValueChange($event)" /><span *ngIf="suffix">{{suffix}}</span>',
    providers: [MakeProvider(DkNumberInputComponent)]
})

export class DkNumberInputComponent implements ControlValueAccessor {
    @Input()
    public inputId: string;

    @Input()
    public inputReadonly: boolean;

    @Input()
    public suffix: string;

    value: string = null;

    writeValue(value: number) {
        if (value != null) {
            this.value = this.dkNumberPipe.transform(value, 2);
        } else {
            this.value = null;
        }
    }

    onValueChange(value) {
        let result = null;
        if (value != null) {
            this.value = value;
            result = this.dkNumberPipe.parse(this.value);
        }

        this.onChange(result);
    }

    onChange = (_) => {};
    onTouched = () => {};

    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }

    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

    constructor(private dkNumberPipe: DkNumberPipe) {
    }
}